import type { ReactElement } from "react";
import { getFontFamily } from "@/theme/typography";
interface MindmapCollapsedCountBadgeProps {
    childCount: number;
}
export function MindmapCollapsedCountBadge({ childCount, }: MindmapCollapsedCountBadgeProps): ReactElement {
    return (
    <div style={{
            position: "absolute",
            top: -10,
            right: -10,
            minWidth: 22,
            height: 22,
            borderRadius: 999,
            padding: "0 7px",
            backgroundColor: "rgba(255, 255, 255, 0.11)",
            border: "1px solid rgba(255, 255, 255, 0.08)",
            backdropFilter: "blur(1px)",
            WebkitBackdropFilter: "blur(1px)",
            color: "#FFFFFF",
            fontSize: 11,
            fontWeight: 600,
            fontFamily: getFontFamily(),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
        }}>
      {childCount}
    </div>
    );
}
